<template>
  <v-container grid-list-xl fluid class="pa-0">
    <v-toolbar class="elevation-1">
      <h4>Sign In</h4>
      <v-spacer></v-spacer>
      <v-btn-toggle fluid v-model="userType" class="d-flex elevation-0">
        <v-btn
          v-for="type in userTypes"
          :key="type"
          :value="type.toLowerCase()"
          class="elevation-0"
          color="#E0E0E0"
          >{{ type }}</v-btn
        >
      </v-btn-toggle>
    </v-toolbar>
    <v-layout row wrap class="pl-4 pr-4 pt-3">
      <v-flex lg12>
        <v-card>
          <v-toolbar card color="white">
            <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Search..."
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
            ></v-text-field>
            <v-btn icon>
              <v-icon>filter_list</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="complex.headers"
              :search="search"
              :items="complex.items"
              :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
              class="elevation-1"
              item-key="name"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-chip>{{ props.item.holder_type.toUpperCase() }}</v-chip>
                </td>
                <td>{{ props.item.first_name }}</td>
                <td>{{ props.item.last_name }}</td>
                <td>{{ props.item.sign_in_date }}</td>
                <td>{{ props.item.sign_in_time }}</td>
                <td>{{ titleCase(props.item.station) }}</td>
                <td v-if="permitted('wwcc')">
                  {{ wwccStatus(props.item.wwcc_card) }}
                </td>
                <td>
                  <v-btn color="info" small @click="handleMoreInfo(props.item)"
                    >View</v-btn
                  >
                  <!-- <v-btn
                      color="indigo"
                      dark
                      small
                      @click="handleSignOut(props.item)"
                      >Sign Out
                  </v-btn>-->
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
import Helpers from "@/mixins/helpers";
import Util from "@/util";
export default {
  mixins: [APIAttendance, Helpers],
  data() {
    return {
      search: "",
      userType: "all",
      userTypes: Util.enabledUserTypes(),
      complex: {
        selected: [],
        headers: [
          {
            text: "Type",
            value: "holder_type"
          },
          {
            text: "First Name",
            value: "first_name"
          },
          {
            text: "Last Name",
            value: "last_name"
          },
          {
            text: "Date",
            value: "sign_in_date"
          },
          {
            text: "Time",
            value: "sign_in_time"
          },
          {
            text: "Station",
            value: "station"
          }
        ],
        items: []
      }
    };
  },
  watch: {
    userType: {
      handler: function() {
        this.handleGet();
      }
    }
  },
  created() {
    if (this.permitted("wwcc")) {
      this.complex.headers.push({
        text: "wwcc card",
        value: "wwcc_card"
      });
    }
    this.complex.headers.push({
      text: "Action",
      value: ""
    });
    this.handleGet();
  },
  methods: {
    handleGet: async function() {
      try {
        if (this.userType === "all") {
          this.complex.items = await this.signIn(this.toDay);
        } else {
          this.complex.items = await this.signIn(this.toDay, this.userType);
        }
      } catch (error) {
        this.$toast.error("Failed to fetch records!", "Error", {
          position: "topCenter"
        });
      }
    },

    handleMoreInfo(row) {
      this.$router.push({
        name: "signedIn View",
        params: { object: row, id: row._id }
      });
    }
  }
};
</script>
